<template>
  <div class="app-detail">
    <ChatIndex class="chatContent" :hideApp="true"></ChatIndex>
  </div>
</template>

<script>
import ChatIndex from '../chat/index'

export default {
  name: 'AppDetail',
  components: {
    ChatIndex
  },
  data() {
    return {
     
    }
  },
  props: {
    title: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    
  },
  mounted () {
  }
}

</script>

<style scoped lang="less">
.app-detail {
  // padding: 26px 19px 0 19px;
}
</style>
